import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AppProvider, useApp } from './context/AppContext';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import UserPanel from './pages/UserPanel';
import Admin from './pages/Admin';
import Album from './pages/Album';
import Gallery from './pages/Gallery';
import GalleryIndex from './pages/GalleryIndex';
import Help from './pages/Help';
import Clients from './pages/Clients';
import InstallPrompt from './components/InstallPrompt';
import ContextualWhatsApp from './components/ContextualWhatsApp';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function ProtectedUser({ children }) {
  const { currentUser, booting } = useApp();
  if (booting) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#F8F8FC' }}>
        <div className="text-sm font-medium" style={{ color: '#4a4a5c' }}>Carregando…</div>
      </div>
    );
  }
  if (!currentUser) return <Navigate to="/auth" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/painel" element={<ProtectedUser><UserPanel /></ProtectedUser>} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/album/:code" element={<Album />} />
          <Route path="/galeria" element={<ProtectedUser><GalleryIndex /></ProtectedUser>} />
          <Route path="/galeria/:code" element={<ProtectedUser><Gallery /></ProtectedUser>} />
          <Route path="/ajuda" element={<Help />} />
          <Route path="/painel/clientes" element={<ProtectedUser><Clients /></ProtectedUser>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
        <InstallPrompt />
        <ContextualWhatsApp />
      </BrowserRouter>
    </AppProvider>
    </ErrorBoundary>
  );
}

export default App;
